import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { ACTION_BY_FILTERS_KEY } from "@/Constants/common";
import {
  _fetchCandidateDocuments,
  _fetchCandidateDetails,
  _getCandidateComplianceUrl,
  _onOffOverRideComplianceForBankCandidate,
  _resendComplianceNotificationToCandidate,
  _updateBankCandidateDocuments,
} from "@/services/clientcandidatedetail";
import {
  _getBookedCandidates,
  _getBookedShifts as _getExpandedUpComingShifts,
  _getWorkedCandidates,
  _getWorkedShifts as _getExpandedWorkHistory,
} from "@/services/clientcandidates";
import {
  handleAPICatch,
  showPromiseToast,
  showSuccessToast,
} from "@/utilities/utils";

import {
  formatBookedWorkedCandidates,
  formatCandidateDetails,
  formatExpandedShifts,
} from "../utilities/dataFormatter";
const initialState = {
  showProfile: true,
  candidateDetails: {},
  isLoading: false,
  activeDetailListing: "",
  activeComplianceTab: "core",
  candidateCalData: {},
  candidateAvailabilityData: {},
  toggleListingSelection: false,
  candidateShiftScheduleFilter: {
    shift_status: "",
  },
  resetcandidateShiftScheduleFilter: {
    shift_status: "",
  },

  upcomingSorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  workHistorySorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  shiftCompletedCount: 0,

  // Listing
  candidateUpComingShifts: [],
  candidateWorkedHistory: [],
  candidateDocuments: {},

  // Total Count
  totalUpcomingShifts: 0,
  totalWorkedHistory: 0,

  // Selection
  selectedUpComingShifts: [],
  selectedWorkedHistory: [],
  selectedDocuments: [],

  // Filters
  upComingShiftFilters: {
    search: "",
    contractDateFrom: "",
    bookedDateFrom: "",
    bookedDateTo: "",
    actionBy: "",
  },
  workedHistoryFilters: {
    search: "",
    contractReferenceNo: "",
    contractDateFrom: "",
    contractDateTo: "",
    ...ACTION_BY_FILTERS_KEY,
  },
  complianceFilters: {
    search: "",
  },

  // Select All
  isUpcomingShiftSelectedAll: false,
  isWorkedHistorySelectedAll: false,

  // Pagination [Compliance Does not have pagination]
  upComingShiftPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  workedHistoryPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  oldUpcomingFilters: {},
  oldWorkFilters: {},
  // View
  upcomingShiftView: "shifts",
  workedHistoryView: "shifts",

  //Filter
  upComingShiftShowFiltersModal: false,
  workedHistoryShowFiltersModal: false,
  editBankCandidateComplianceModalProfileModal: false,
  candidateDetLoading: false,
};

export const fetchCandidateDocuments = createAsyncThunk(
  "clientCandidateDetail/fetchCandidateDocuments",
  async (data, thunkAPI) => {
    let clientCandidateDetail = thunkAPI.getState().clientCandidateDetail;
    const _data = {
      candidate_id: clientCandidateDetail.candidateDetails.candidate_id,
      search: clientCandidateDetail.complianceFilters.search,
      type: "view",
    };
    thunkAPI.dispatch(deSelectAllListings());
    let _toggleListingSelection = clientCandidateDetail.toggleListingSelection;
    thunkAPI.dispatch(updateToggleListingSelection(!_toggleListingSelection));
    thunkAPI.dispatch(updateSelectedDocuments([]));
    const response = _fetchCandidateDocuments(_data);
    response
      .then((res) => {
        const {
          data: { docs },
        } = res;
        thunkAPI.dispatch(updateCandidateDocuments(docs));
        thunkAPI.dispatch(setLoading(false));
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

export const fetchWorkHistory = createAsyncThunk(
  "clientCandidateDetail/fetchWorkHistory",
  async (data, thunkAPI) => {
    let paginationData =
      thunkAPI.getState().clientCandidateDetail.workedHistoryPagination;
    let filtersData =
      thunkAPI.getState().clientCandidateDetail.workedHistoryFilters;
    let sortingData =
      thunkAPI.getState().clientCandidateDetail.workHistorySorting;
    if (_.isEmpty(data)) {
      data = {
        ...filtersData,
      };
    }
    if (paginationData.isLastPage) {
      return thunkAPI.dispatch(setLoading(false));
    }
    thunkAPI.dispatch(toggleUpcomingShiftsSelectAll(false));
    const _data = {
      ...filtersData,
      candidateId: [
        thunkAPI.getState().clientCandidateDetail.candidateDetails.candidate_id,
      ],
      currentPage: paginationData.currentPage,
      ...sortingData,
      // search:thunkAPI.getState().clientCandidateDetail.workedHistoryFilters.search,
      listView: thunkAPI.getState().clientCandidateDetail.workedHistoryView,
    };
    const response = _getWorkedCandidates(_data);
    response
      .then((res) => {
        const {
          data: { worked_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        const data = formatBookedWorkedCandidates(worked_list, "worked");
        thunkAPI.dispatch(
          updateWorkedHistoryPagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        thunkAPI.dispatch(updateWorkHistoryCounts(totalCount));

        let prevList =
          currentPage === 1
            ? []
            : _.uniq(
                thunkAPI.getState().clientCandidateDetail
                  .candidateWorkedHistory,
              );
        let firstcontract_id = data.length > 0 ? data[0].contract_id : null;
        thunkAPI.dispatch(updateTotalWorkedHistory(totalCount));
        if (
          prevList.length > 0 &&
          prevList.find((item) => item.contract_id === firstcontract_id) !==
            undefined
        ) {
          //
        } else {
          thunkAPI.dispatch(updateWorkedHistory([...prevList, ...data]));
        }
        return res;
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        thunkAPI.dispatch(setLoading(false));
      });
  },
);

export const fetchExpandedWorkHistory = createAsyncThunk(
  "clientCandidateDetail/fetchExpandedWorkHistory",
  async (data, thunkAPI) => {
    const { contractId } = data;
    const response = _getExpandedWorkHistory(data);
    response
      .then((res) => {
        const {
          data: { worked_contract_shift_list },
        } = res;
        const data = formatExpandedShifts(worked_contract_shift_list, "worked");
        thunkAPI.dispatch(
          updateExpandedWorkHistory({
            contract_id: contractId,
            shifts: data,
          }),
        );
      })
      .catch((error) => {
        // handleAPICatch(error);
        return thunkAPI.rejectWithValue(error);
      });
  },
);

export const fetchUpcomingShifts = createAsyncThunk(
  "clientCandidateDetail/fetchUpcomingShifts",
  async (data, thunkAPI) => {
    let paginationData =
      thunkAPI.getState().clientCandidateDetail.upComingShiftPagination;
    let filtersData =
      thunkAPI.getState().clientCandidateDetail.upComingShiftFilters;
    let sortingData = thunkAPI.getState().clientCandidateDetail.upcomingSorting;

    if (_.isEmpty(data)) {
      data = {
        ...filtersData,
      };
    }
    if (paginationData.isLastPage) {
      return thunkAPI.dispatch(setLoading(false));
    }
    thunkAPI.dispatch(toggleWorkedHistorySelectAll(false));
    const _data = {
      ...filtersData,
      candidateId: [
        thunkAPI.getState().clientCandidateDetail.candidateDetails.candidate_id,
      ],
      currentPage: paginationData.currentPage,
      ...sortingData,
      // search: thunkAPI.getState().clientCandidateDetail.upComingShiftFilters.search,
      listView: thunkAPI.getState().clientCandidateDetail.upcomingShiftView,
    };
    const response = _getBookedCandidates(_data);
    response
      .then((res) => {
        const {
          data: { booked_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        const data = formatBookedWorkedCandidates(booked_list, "booked");
        thunkAPI.dispatch(
          updateUpComingShiftPagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage ? true : false,
          }),
        );
        let prevList =
          currentPage === 1
            ? []
            : _.uniq(
                thunkAPI.getState().clientCandidateDetail
                  .candidateUpComingShifts,
              );
        let firstcontract_id = data.length > 0 ? data[0].contract_id : null;
        thunkAPI.dispatch(updateTotalUpcomingShifts(totalCount));
        if (
          prevList.length > 0 &&
          prevList.find((item) => item.contract_id === firstcontract_id) !==
            undefined
        ) {
          //
        } else {
          thunkAPI.dispatch(updateUpComingShifts([...prevList, ...data]));
        }
        return res;
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        thunkAPI.dispatch(setLoading(false));
      });
  },
);
export const fetchExpandedUpcomingShifts = createAsyncThunk(
  "clientCandidateDetail/fetchExpandedUpcomingShifts",
  async (data, thunkAPI) => {
    const { contractId } = data;
    const response = _getExpandedUpComingShifts(data);
    response
      .then((res) => {
        const {
          data: { booked_contract_shift_list },
        } = res;
        const data = formatExpandedShifts(booked_contract_shift_list);
        thunkAPI.dispatch(
          updateExpandedUpcomingShifts({
            contract_id: contractId,
            shifts: data,
          }),
        );
      })
      .catch((error) => {
        // handleAPICatch(error);
        return thunkAPI.rejectWithValue(error);
      });
  },
);

// _resendComplianceNotificationToCandidate

export const resendComplianceNotificationToCandiate = createAsyncThunk(
  "clientCandidateDetail/resendComplianceNotificationToCandiate",
  async (data, thunkAPI) => {
    const { candidate_id, loading, setLoading } = data;
    if (loading) return;
    setLoading(true);
    const response = _resendComplianceNotificationToCandidate({
      candidate_id: candidate_id,
    });
    response
      .then((res) => {
        const {
          data, // This assumes data is directly at the top level of the response
        } = res;
        showSuccessToast(data[0].message); // Display the success message
      })
      .catch((error) => {
        // showErrorToast(error.data.error)
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);

export const turnOnOffOverRideComplianceForBankCandidate = createAsyncThunk(
  "clientCandidateDetail/turnOnOffOverRideComplianceForBankCandidate",
  async (data, thunkAPI) => {
    const { invitation_ids, loading, setLoading, status } = data;
    const response = _onOffOverRideComplianceForBankCandidate({
      invitation_ids: invitation_ids,
      status: data.status,
    });
    response
      .then((res) => {
        const {
          data: { message }, // This assumes data is directly at the top level of the response
        } = res;
        showSuccessToast(message); // Display the success message
      })
      .catch((error) => {
        // showErrorToast(error.data.error)
        handleAPICatch(error);
      });
    // .finally(() => {
    //   setLoading(false);
    // });
  },
);

export const updateBankCandidateCompliance = createAsyncThunk(
  "clientUsers/updateBankCandidateCompliance",
  async (data, { dispatch, getState }) => {
    const { postData, setSubmitting, callback } = data;
    setSubmitting(true);
    try {
      let response = await _updateBankCandidateDocuments(postData);
      // console.log("res", response)
      const { message } = response;
      showSuccessToast("Compliance has been successfully updated !");
      dispatch(toggleEditBankCandidateComplianceModal(false));
      callback && callback();
    } catch (error) {
      handleAPICatch(error);
    } finally {
      setSubmitting(false);
    }
  },
);

export const handleFetchCandidateDetails = createAsyncThunk(
  "clientUsers/handleFetchCandidateDetails",
  async (data, { dispatch, getState }) => {
    dispatch(setCandidateDetLoading(true));
    const response = _fetchCandidateDetails({ candidate_id: data });
    response
      .then((res) => {
        const {
          data: { candidate_details },
        } = res;
        let _data = formatCandidateDetails(candidate_details);
        dispatch(
          setCandidateDetails({
            ..._data,
            candidate_id: data,
          }),
        );
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        dispatch(setCandidateDetLoading(false));
      });
  },
);

export const openCandidateComplianceDoc = createAsyncThunk(
  "clientCandidateDetail/resendComplianceNotificationToCandiate",
  async (data, thunkAPI) => {
    const response = _getCandidateComplianceUrl(data);
    showPromiseToast(response, {
      loading: "Opening Compliance Document.",
      success: "Compliance Document Opened in new tab.",
      error: "Failed to open compliance document",
    });
    response
      .then((res) => {
        const {
          data: { document_url },
        } = res;
        window.open(document_url, "_blank");
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

const clientCandidateDetailSlice = createSlice({
  name: "clientCandidateDetail",
  initialState,
  reducers: {
    /**
     * Set candidate details in the state.
     *
     * @param {type} state - The current state
     * @param {type} action - The action object
     * @return {type} undefined
     */
    setCandidateDetails: (state, action) => {
      state.candidateDetails = action.payload;
    },
    /**
     * Set the loading state based on the action payload.
     *
     * @param {type} state - the current state
     * @param {type} action - the action object
     * @return {type} undefined
     */
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCandidateDetLoading: (state, action) => {
      state.candidateDetLoading = action.payload;
    },
    /**
     * Set the showProfile property in the state to the value provided in the action payload.
     *
     * @param {type} state - The current state object
     * @param {type} action - The action object containing the payload
     * @return {type} void
     */
    setShowProfile: (state, action) => {
      state.showProfile = action.payload;
    },
    /**
     * Update the active detail listing in the state.
     *
     * @param {Object} state - the current state
     * @param {Object} action - the action with payload
     * @return {void}
     */
    updateActiveDetailListing: (state, action) => {
      state.activeDetailListing = action.payload;
    },
    /**
     * Updates the compliance type in the state.
     *
     * @param {type} state - description of state parameter
     * @param {type} action - description of action parameter
     * @return {type} description of return value
     */
    updateComplianceType: (state, action) => {
      state.activeComplianceTab = action.payload;
    },
    /**
     * Set candidateCalData in the state with the provided payload.
     *
     * @param {type} state - The current state
     * @param {type} action - The action containing the payload
     * @return {type}
     */
    setCandidateCalData: (state, action) => {
      state.candidateCalData = action.payload;
    },
    setCandidateAvailabilityData: (state, action) => {
      state.candidateAvailabilityData = action.payload;
    },
    updateCandidateShiftScheduleFilter: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.candidateShiftScheduleFilter =
          initialState.candidateShiftScheduleFilter;
      } else {
        state.candidateShiftScheduleFilter = {
          ...state.candidateShiftScheduleFilter,
          ...action.payload,
        };
      }
    },

    resetCandidateShiftScheduleFilter: (state, action) => {
      state.candidateShiftScheduleFilter =
        state.resetcandidateShiftScheduleFilter;
    },

    updateToggleListingSelection: (state, action) => {
      state.toggleListingSelection = action.payload;
    },

    // Listing
    updateUpComingShifts: (state, action) => {
      state.candidateUpComingShifts = action.payload;
    },
    updateWorkedHistory: (state, action) => {
      state.candidateWorkedHistory = action.payload;
    },
    updateCandidateDocuments: (state, action) => {
      state.candidateDocuments = action.payload;
    },

    // Pagination
    updateUpComingShiftPagination: (state, action) => {
      state.upComingShiftPagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    updateWorkedHistoryPagination: (state, action) => {
      state.workedHistoryPagination = {
        ...state.workedHistoryPagination,
        ...action.payload,
      };
    },

    // Filters
    updateUpComingShiftFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.upComingShiftFilters = {
          search: state.upComingShiftFilters.search,
          ...initialState.upComingShiftFilters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.upComingShiftFilters = initialState.upComingShiftFilters;
        } else {
          state.upComingShiftFilters = {
            ...state.upComingShiftFilters,
            ...action.payload,
          };
        }
      }
    },
    reStateUpComingShiftFilters: (state, action) => {
      state.upComingShiftFilters = state.oldUpcomingFilters;
    },
    reStateWorkHistroyFilters: (state, action) => {
      state.workedHistoryFilters = state.oldWorkFilters;
    },
    updateWorkedHistoryFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.workedHistoryFilters = {
          search: state.workedHistoryFilters.search,
          ...initialState.workedHistoryFilters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.workedHistoryFilters = initialState.workedHistoryFilters;
        } else {
          state.workedHistoryFilters = {
            ...state.workedHistoryFilters,
            ...action.payload,
          };
        }
      }
    },
    updateComplianceFilters: (state, action) => {
      state.complianceFilters = {
        ...state.complianceFilters,
        ...action.payload,
      };
    },

    // Selection
    updateSelectedUpcomingShifts: (state, action) => {
      state.selectedUpComingShifts = action.payload;
      if (action.payload.length === 0) {
        state.isUpcomingShiftSelectedAll = false;
      }
    },
    updateSelectedWorkedHistory: (state, action) => {
      state.selectedWorkedHistory = action.payload;
      if (action.payload.length === 0) {
        state.isWorkedHistorySelectedAll = false;
      }
    },
    updateSelectedDocuments: (state, action) => {
      state.selectedDocuments = action.payload;
    },
    deSelectAllListings: (state) => {
      state.selectedUpComingShifts = [];
      state.selectedWorkedHistory = [];
      state.selectedDocuments = [];
      state.isUpcomingShiftSelectedAll = false;
      state.isWorkedHistorySelectedAll = false;
      state.toggleListingSelection = !state.toggleListingSelection;
    },

    // View
    updateUpComingShiftsView: (state, action) => {
      state.upcomingShiftView = action.payload;
    },
    updateWorkedHistoryView: (state, action) => {
      state.workedHistoryView = action.payload;
    },

    // Expanded
    updateExpandedUpcomingShifts: (state, action) => {
      const { contract_id, shifts } = action.payload;
      let candidateUpComingShiftsClone = [...state.candidateUpComingShifts];
      state.candidateUpComingShifts = candidateUpComingShiftsClone.map(
        (ele) => {
          if (ele.contract_id == contract_id) {
            ele.shifts = shifts;
          }
          return ele;
        },
      );
    },
    updateExpandedWorkHistory: (state, action) => {
      const { contract_id, shifts } = action.payload;
      let candidateWorkedHistoryClone = [...state.candidateWorkedHistory];
      state.candidateWorkedHistory = candidateWorkedHistoryClone.map((ele) => {
        if (ele.contract_id == contract_id) {
          ele.shifts = shifts;
        }
        return ele;
      });
    },

    // Total Count
    updateTotalUpcomingShifts: (state, action) => {
      state.totalUpcomingShifts = action.payload;
    },
    updateTotalWorkedHistory: (state, action) => {
      state.totalWorkedHistory = action.payload;
    },
    updateUpComingShiftsSorting: (state, action) => {
      state.upcomingSorting = action.payload;
    },
    updateWorkHistorySorting: (state, action) => {
      state.workHistorySorting = action.payload;
    },

    // Select All
    toggleUpcomingShiftsSelectAll: (state, action) => {
      state.isUpcomingShiftSelectedAll = action.payload;
    },
    toggleWorkedHistorySelectAll: (state, action) => {
      state.isWorkedHistorySelectedAll = action.payload;
    },
    toggleCandidateUpcomingFilter: (state, action) => {
      if (action.payload) {
        state.oldUpcomingFilters = state.upComingShiftFilters;
      }
      state.upComingShiftShowFiltersModal = action.payload;
    },
    toggleCandidateWorkedFilter: (state, action) => {
      if (action.payload) {
        state.oldWorkFilters = state.workedHistoryFilters;
      }
      state.workedHistoryShowFiltersModal = action.payload;
    },

    toggleEditBankCandidateComplianceModal: (state, action) => {
      state.editBankCandidateComplianceModal = action.payload;
    },
    updateWorkHistoryCounts: (state, action) => {
      state.shiftCompletedCount = action.payload;
    },
  },
});

export const {
  setCandidateDetails,
  setLoading,
  setCandidateDetLoading,
  setShowProfile,
  updateActiveDetailListing,
  updateComplianceType,
  setCandidateCalData,
  setCandidateAvailabilityData,
  updateCandidateShiftScheduleFilter,
  resetCandidateShiftScheduleFilter,
  reStateUpComingShiftFilters,
  reStateWorkHistroyFilters,

  // Listings
  updateUpComingShifts,
  updateWorkedHistory,
  updateCandidateDocuments,

  // Pagination
  updateUpComingShiftPagination,
  updateWorkedHistoryPagination,

  // Filters
  updateUpComingShiftFilters,
  updateWorkedHistoryFilters,
  updateComplianceFilters,
  toggleCandidateUpcomingFilter,
  toggleCandidateWorkedFilter,

  // Selection
  updateSelectedDocuments,
  updateSelectedUpcomingShifts,
  updateSelectedWorkedHistory,
  deSelectAllListings,
  updateToggleListingSelection,

  // View
  updateUpComingShiftsView,
  updateWorkedHistoryView,

  // Expanded
  updateExpandedUpcomingShifts,
  updateExpandedWorkHistory,

  // Total
  updateTotalUpcomingShifts,
  updateTotalWorkedHistory,

  // Select All
  toggleUpcomingShiftsSelectAll,
  toggleWorkedHistorySelectAll,

  //sorting
  updateUpComingShiftsSorting,
  updateWorkHistorySorting,
  toggleEditBankCandidateComplianceModal,
  updateWorkHistoryCounts,
} = clientCandidateDetailSlice.actions;

export default clientCandidateDetailSlice.reducer;
